import { IDENTITY_TYPE_MAP, BA_IDENTITY_TYPES_LIST, BC_IDENTITY_TYPES_LIST } from '@tt4b/ttam-enums';
const TTS_SINGLE_VIDEO_LINK = 'https://ads.tiktok.com/help/article/requesting-tiktok-shop-access-business-center?';
export function getPermissionLink({
  type,
  bcId,
  TTSLink = TTS_SINGLE_VIDEO_LINK,
}: {
  type: number;
  bcId: string | number;
  TTSLink?: string;
}) {
  if (type === IDENTITY_TYPE_MAP.TTS_TT) {
    return TTSLink;
  } else if (BA_IDENTITY_TYPES_LIST.includes(type)) {
    return 'https://ads.tiktok.com/ac/page/settings';
  } else if (BC_IDENTITY_TYPES_LIST.includes(type)) {
    return `https://business.tiktok.com/manage/tiktok?org_id=${bcId}`;
  }
}
